let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("k1wpE")).then(() => parcelRequire('coZXG'));